
import {Vue, Component} from 'vue-property-decorator'
import { VDivider } from 'vuetify/lib'

@Component({
  name: 'Divider',
  extends: VDivider as any,
})
export default class Divider extends Vue {}
